import {
  FaSuperpowers,
  FaDiceD20,
  FaRegLightbulb,
} from "@onemind-services-llc/react-icons-ng/fa";

export const PROGRAM_DETAILS_LIST = [
  {
    content:
      "Our mission is to achieve groundbreaking advancements that make every aspect, from inception to cloud, practical and easily accessible.",
    icon: FaSuperpowers,
    title: "Commission Based",
  },
  {
    content:
      "Innovation distinguishes between a leader and a follower, as Steve Jobs says. We bring innovation to your business which distinguishes you from your competitors, helps you scale faster, optimize your investments and realize your goals.",
    icon: FaRegLightbulb,
    title: "White Label",
  },
  {
    content:
      " With the accelerating pace of technological innovations, older technologies and processes are steadily falling behind the speed and power curve. Today’s business requires IT that is agile and nimble to keep up with today’s demands.",
    icon: FaDiceD20,
    title: "Sell With CloudMyLab",
  },
];
